import {normalize} from 'normalizr';
import swal from 'sweetalert2';
import {getEndpoint, getHeaders} from '../../helpers/endpoint';
import {playerListSchema, playerSchema} from '../../schemas/player';
import {suggestedQuotationsSchema} from '../../schemas/suggestedQuotations';
import {receiveEntities} from '../entities';

export const REQUEST_FETCH_PLAYER = 'REQUEST_FETCH_PLAYER';
export const SUCCESS_FETCH_PLAYER = 'SUCCESS_FETCH_PLAYER';
export const FAIL_FETCH_PLAYER = 'FAIL_FETCH_PLAYER';

export const fetchPlayer = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_PLAYER, payload, scope});

    fetch(getEndpoint('fetchPlayer', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_PLAYER,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successFetchPlayer(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_PLAYER) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchPlayer(response, payload, scope) {
  return dispatch => {
    const normalized = normalize(response, playerSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_PLAYER,
      receivedAt: Date.now(),
      id: normalized.result,
      payload,
      scope,
    });
  };
}

export const REQUEST_FETCH_PLAYERS = 'REQUEST_FETCH_PLAYERS';
export const SUCCESS_FETCH_PLAYERS = 'SUCCESS_FETCH_PLAYERS';
export const FAIL_FETCH_PLAYERS = 'FAIL_FETCH_PLAYERS';

export const fetchPlayers = (payload, scope, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_PLAYERS, payload, scope});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchPlayers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          dispatch({
            type: FAIL_FETCH_PLAYERS,
            error: data.error,
            payload,
            scope,
          });
          if (onError) onError(data.error, payload.type);
        } else {
          dispatch(successFetchPlayers(data, payload, scope));
          if (onSuccess) onSuccess(data, payload);
        }
      })
      .catch((error, type = FAIL_FETCH_PLAYERS) => {
        dispatch({type, error, payload, scope});
        if (onError) onError(error, type);
      });
  };
};

function successFetchPlayers(response, payload, scope) {
  return dispatch => {
    const normalized = normalize(response.players, playerListSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_PLAYERS,
      receivedAt: Date.now(),
      ids: normalized.result,
      payload,
      scope,
    });
  };
}

export const REQUEST_FETCH_PLAYERS_QUOTATIONS =
  'REQUEST_FETCH_PLAYERS_QUOTATIONS';
export const SUCCESS_FETCH_PLAYERS_QUOTATIONS =
  'SUCCESS_FETCH_PLAYERS_QUOTATIONS';
export const FAIL_FETCH_PLAYERS_QUOTATIONS = 'FAIL_FETCH_PLAYERS_QUOTATIONS';

export const fetchPlayersQuotations = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_PLAYERS_QUOTATIONS, payload, scope});

    fetch(getEndpoint('fetchPlayersQuotations', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_PLAYERS_QUOTATIONS,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successFetchPlayersQuotations(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_PLAYERS_QUOTATIONS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchPlayersQuotations(response, payload, scope) {
  return dispatch => {
    const normalized = normalize(response, playerListSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_PLAYERS_QUOTATIONS,
      receivedAt: Date.now(),
      ids: normalized.result,
      payload,
      scope,
    });
  };
}

export const REQUEST_FETCH_SUGGESTED_QUOTATIONS =
  'REQUEST_FETCH_SUGGESTED_QUOTATIONS';
export const SUCCESS_FETCH_SUGGESTED_QUOTATIONS =
  'SUCCESS_FETCH_SUGGESTED_QUOTATIONS';
export const FAIL_FETCH_SUGGESTED_QUOTATIONS =
  'FAIL_FETCH_SUGGESTED_QUOTATIONS';

export const fetchSuggestedQuotations = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_SUGGESTED_QUOTATIONS, payload, scope});

    fetch(getEndpoint('fetchSuggestedQuotations', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_SUGGESTED_QUOTATIONS,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successFetchSuggestedQuotations(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_SUGGESTED_QUOTATIONS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchSuggestedQuotations(response, payload, scope) {
  return dispatch => {
    const normalized = normalize(response, suggestedQuotationsSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_SUGGESTED_QUOTATIONS,
      receivedAt: Date.now(),
      id: normalized.result,
      payload,
      scope,
    });
  };
}

export const REQUEST_UPDATE_SUGGESTED_QUOTATION =
  'REQUEST_UPDATE_SUGGESTED_QUOTATION';
export const SUCCESS_UPDATE_SUGGESTED_QUOTATION =
  'SUCCESS_UPDATE_SUGGESTED_QUOTATION';
export const FAIL_UPDATE_SUGGESTED_QUOTATION =
  'FAIL_UPDATE_SUGGESTED_QUOTATION';

export const updateSuggestedQuotation = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_SUGGESTED_QUOTATION, payload, scope});

    const {suggestedQuotation, playerId} = payload;

    fetch(getEndpoint('updateSuggestedQuotation', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({
        suggestedQuotation,
        playerId,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_UPDATE_SUGGESTED_QUOTATION,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdateSuggestedQuotation(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_SUGGESTED_QUOTATION) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdateSuggestedQuotation(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_SUGGESTED_QUOTATION,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_APPLY_SUGGESTED_QUOTATION =
  'REQUEST_APPLY_SUGGESTED_QUOTATION';
export const FAIL_APPLY_SUGGESTED_QUOTATION = 'FAIL_APPLY_SUGGESTED_QUOTATION';

export const applySuggestedQuotations = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_APPLY_SUGGESTED_QUOTATION, payload, scope});
    return fetch(getEndpoint('applySuggestedQuotations', payload), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          return dispatch({
            type: FAIL_APPLY_SUGGESTED_QUOTATION,
            error: data.error,
            payload,
            scope,
          });
        else
          return dispatch(
            successApplySuggestedQuotations(data, payload, scope),
          );
      })
      .catch((error, type = FAIL_APPLY_SUGGESTED_QUOTATION) =>
        dispatch({type, error, payload, scope}),
      );
  };
};

function successApplySuggestedQuotations(response, payload, scope) {
  return dispatch => {
    dispatch(
      fetchSuggestedQuotations({championship: payload.id.split('_')[3]}, scope),
    );
  };
}

export const REQUEST_UPDATE_PLAYER_QUOTATION =
  'REQUEST_UPDATE_PLAYER_QUOTATION';
export const SUCCESS_UPDATE_PLAYER_QUOTATION =
  'SUCCESS_UPDATE_PLAYER_QUOTATION';
export const FAIL_UPDATE_PLAYER_QUOTATION = 'FAIL_UPDATE_PLAYER_QUOTATION';

export const updatePlayerQuotation = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_PLAYER_QUOTATION, payload, scope});

    fetch(getEndpoint('updatePlayer', payload), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_UPDATE_PLAYER_QUOTATION,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdatePlayerQuotation(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_PLAYER_QUOTATION) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdatePlayerQuotation(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_PLAYER_QUOTATION,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_UPDATE_PLAYER_POSITION_ULTRA =
  'REQUEST_UPDATE_PLAYER_POSITION_ULTRA';
export const SUCCESS_UPDATE_PLAYER_POSITION_ULTRA =
  'SUCCESS_UPDATE_PLAYER_POSITION_ULTRA';
export const FAIL_UPDATE_PLAYER_POSITION_ULTRA =
  'FAIL_UPDATE_PLAYER_POSITION_ULTRA';

export const updatePlayerUltraPosition = (id, payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_PLAYER_POSITION_ULTRA, payload, scope});

    fetch(getEndpoint('updatePlayer', {id}), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_UPDATE_PLAYER_POSITION_ULTRA,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdatePlayerUltraPosition(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_PLAYER_POSITION_ULTRA) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdatePlayerUltraPosition(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_PLAYER_POSITION_ULTRA,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_UPDATE_PLAYER_POSITION = 'REQUEST_UPDATE_PLAYER_POSITION';
export const SUCCESS_UPDATE_PLAYER_POSITION = 'SUCCESS_UPDATE_PLAYER_POSITION';
export const FAIL_UPDATE_PLAYER_POSITION = 'FAIL_UPDATE_PLAYER_POSITION';

export const updatePlayerPosition = (id, payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_PLAYER_POSITION, payload, scope});

    fetch(getEndpoint('updatePlayer', {id}), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_UPDATE_PLAYER_POSITION,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdatePlayerPosition(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_PLAYER_POSITION) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdatePlayerPosition(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_PLAYER_POSITION,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_UPDATE_PLAYER_ACTIVE = 'REQUEST_UPDATE_PLAYER_ACTIVE';
export const SUCCESS_UPDATE_PLAYER_ACTIVE = 'SUCCESS_UPDATE_PLAYER_ACTIVE';
export const FAIL_UPDATE_PLAYER_ACTIVE = 'FAIL_UPDATE_PLAYER_ACTIVE';

export const updatePlayerActive = (id, payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_PLAYER_ACTIVE, payload, scope});

    fetch(getEndpoint('updatePlayer', {id}), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_UPDATE_PLAYER_ACTIVE,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdatePlayerActive(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_PLAYER_ACTIVE) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdatePlayerActive(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_PLAYER_ACTIVE,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_UPDATE_PLAYER_PROPERTY = 'REQUEST_UPDATE_PLAYER_PROPERTY';
export const SUCCESS_UPDATE_PLAYER_PROPERTY = 'SUCCESS_UPDATE_PLAYER_PROPERTY';
export const FAIL_UPDATE_PLAYER_PROPERTY = 'FAIL_UPDATE_PLAYER_PROPERTY';

export const updatePlayerProperty = (id, payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_PLAYER_PROPERTY, payload, scope});

    fetch(getEndpoint('updatePlayer', {id}), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_UPDATE_PLAYER_PROPERTY,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdatePlayerProperty(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_PLAYER_PROPERTY) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdatePlayerProperty(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_PLAYER_PROPERTY,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_IMPORT_OPTA = 'REQUEST_IMPORT_OPTA';
export const SUCCESS_IMPORT_OPTA = 'SUCCESS_IMPORT_OPTA';
export const FAIL_IMPORT_OPTA = 'FAIL_IMPORT_OPTA';

export const importOpta = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_IMPORT_OPTA, payload, scope});

    fetch(getEndpoint('importOpta', payload), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>${data.error}<br/>` +
              `<pre><code>${JSON.stringify(
                data.error,
                undefined,
                4,
              )}</code></pre>`,
          });
          dispatch({
            type: FAIL_IMPORT_OPTA,
            error: data.error,
            payload,
            scope,
          });
        } else dispatch(successImportOpta(data, payload, scope));
      })
      .catch((error, type = FAIL_IMPORT_OPTA) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successImportOpta(response, payload, scope) {
  swal({
    title: `Job started !`,
    type: 'success',
    html: ``,
  });
  return dispatch => {
    dispatch({
      type: SUCCESS_IMPORT_OPTA,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_UPDATE_LIST_PROD = 'REQUEST_UPDATE_LIST_PROD';
export const SUCCESS_UPDATE_LIST_PROD = 'SUCCESS_UPDATE_LIST_PROD';
export const FAIL_UPDATE_LIST_PROD = 'FAIL_UPDATE_LIST_PROD';

export const updateListProd = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_LIST_PROD, payload, scope});

    fetch(getEndpoint('updateListProd', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>${data.error}<br/>` +
              `<pre><code>${JSON.stringify(data, undefined, 4)}</code></pre>`,
          });
          dispatch({
            type: FAIL_UPDATE_LIST_PROD,
            error: data.error,
            payload,
            scope,
          });
        } else dispatch(successUpdateListProd(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_LIST_PROD) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdateListProd(response, payload, scope) {
  swal({
    title: `Job started !`,
    type: 'success',
    html: ``,
  });
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_LIST_PROD,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_UPDATE_DATA_BY_CHAMP = 'REQUEST_UPDATE_DATA_BY_CHAMP';
export const SUCCESS_UPDATE_DATA_BY_CHAMP = 'SUCCESS_UPDATE_DATA_BY_CHAMP';
export const FAIL_UPDATE_DATA_BY_CHAMP = 'FAIL_UPDATE_DATA_BY_CHAMP';

export const updateDataByChampionshipId = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_DATA_BY_CHAMP, payload, scope});

    fetch(getEndpoint('updateDataByChampionshipId', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>${data.error}<br/>` +
              `<pre><code>${JSON.stringify(
                data.error,
                undefined,
                4,
              )}</code></pre>`,
          });
          dispatch({
            type: FAIL_UPDATE_DATA_BY_CHAMP,
            error: data.error,
            payload,
            scope,
          });
        } else dispatch(successUpdateDataByChamp(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_DATA_BY_CHAMP) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdateDataByChamp(response, payload, scope) {
  swal({
    title: `Job started !`,
    type: 'success',
    html: ``,
  });
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_DATA_BY_CHAMP,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const REQUEST_IN_AND_OUT = 'REQUEST_IN_AND_OUT';
export const SUCCESS_IN_AND_OUT = 'SUCCESS_IN_AND_OUT';
export const FAIL_IN_AND_OUT = 'FAIL_IN_AND_OUT';

export const fetchInAndOut = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_IN_AND_OUT, payload, scope});

    return fetch(getEndpoint('inAndOut', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          return dispatch({
            type: FAIL_IN_AND_OUT,
            error: data.error,
            payload,
            scope,
          });
        } else return dispatch(successFetchInAndOut(data, payload, scope));
      })
      .catch((error, type = FAIL_IN_AND_OUT) =>
        dispatch({type, error, payload, scope}),
      );
  };
};

function successFetchInAndOut(response, payload, scope) {
  return dispatch =>
    dispatch({
      type: SUCCESS_IN_AND_OUT,
      receivedAt: Date.now(),
      success: response.success,
      response,
      payload,
      scope,
    });
}

export const REQUEST_POST_IN_AND_OUT = 'REQUEST_POST_IN_AND_OUT';
export const SUCCESS_POST_IN_AND_OUT = 'SUCCESS_POST_IN_AND_OUT';
export const FAIL_POST_IN_AND_OUT = 'FAIL_POST_IN_AND_OUT';

export const postInAndOut = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_POST_IN_AND_OUT, payload, scope});

    return fetch(getEndpoint('inAndOut', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({players: payload.players}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          return dispatch({
            type: FAIL_POST_IN_AND_OUT,
            error: data.error,
            payload,
            scope,
          });
        } else return dispatch(successPostInAndOut(data, payload, scope));
      })
      .catch((error, type = FAIL_POST_IN_AND_OUT) =>
        dispatch({type, error, payload, scope}),
      );
  };
};

function successPostInAndOut(response, payload, scope) {
  return dispatch =>
    dispatch({
      type: SUCCESS_POST_IN_AND_OUT,
      receivedAt: Date.now(),
      success: response.success,
      response,
      payload,
      scope,
    });
}

export const REQUEST_UPDATE_PLAYER_MATCH_MARK =
  'REQUEST_UPDATE_PLAYER_MATCH_MARK';
export const SUCCESS_UPDATE_PLAYER_MATCH_MARK =
  'SUCCESS_UPDATE_PLAYER_MATCH_MARK';
export const FAIL_UPDATE_PLAYER_MATCH_MARK = 'FAIL_UPDATE_PLAYER_MATCH_MARK';

export const updatePlayerMatchMark = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_PLAYER_MATCH_MARK, payload, scope});

    fetch(getEndpoint('updatePlayerMatchMark', payload), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({ratings: {equipe: payload.mark}}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_UPDATE_PLAYER_MATCH_MARK,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdatePlayerMatchMark(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_PLAYER_MATCH_MARK) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdatePlayerMatchMark(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_UPDATE_PLAYER_MATCH_MARK,
      receivedAt: Date.now(),
      success: response.success,
      payload,
      scope,
    });
  };
}

export const GET_TOP_PLAYERS = 'GET_TOP_PLAYERS';
export const GET_TOP_PLAYERS_SUCCESS = 'GET_TOP_PLAYERS_SUCCESS';
export const GET_TOP_PLAYERS_ERROR = 'GET_TOP_PLAYERS_ERROR';

export const getTopPlayers = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({
      type: GET_TOP_PLAYERS,
      payload,
      scope,
    });

    fetch(getEndpoint('getTopPlayers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: GET_TOP_PLAYERS_ERROR,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successgetTopPlayers(data, payload, scope));
      })
      .catch((error, type = GET_TOP_PLAYERS_ERROR) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successgetTopPlayers(response, payload, scope) {
  return dispatch => {
    let tmp = response.players.map(player => ({
      ...player,
      id: `player_${player.playerid}`,
    }));
    const normalized = normalize(tmp, playerListSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: GET_TOP_PLAYERS_SUCCESS,
      receivedAt: Date.now(),
      ids: normalized.result,
      payload,
      scope,
    });
  };
}

export const GET_FLOP_PLAYERS = 'GET_FLOP_PLAYERS';
export const GET_FLOP_PLAYERS_SUCCESS = 'GET_FLOP_PLAYERS_SUCCESS';
export const GET_FLOP_PLAYERS_ERROR = 'GET_FLOP_PLAYERS_ERROR';

export const getFlopPlayers = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({
      type: GET_FLOP_PLAYERS,
      payload,
      scope,
    });

    fetch(getEndpoint('getFlopPlayers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: GET_FLOP_PLAYERS_ERROR,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successgetFlopPlayers(data, payload, scope));
      })
      .catch((error, type = GET_FLOP_PLAYERS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successgetFlopPlayers(response, payload, scope) {
  return dispatch => {
    let tmp = response.players.map(player => ({
      ...player,
      id: `player_${player.playerid}`,
    }));
    const normalized = normalize(tmp, playerListSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: GET_FLOP_PLAYERS_SUCCESS,
      receivedAt: Date.now(),
      ids: normalized.result,
      payload,
      scope,
    });
  };
}

export const REQUEST_FETCH_FULL_PLAYERS = 'REQUEST_FETCH_FULL_PLAYERS';
export const SUCCESS_FETCH_FULL_PLAYERS = 'SUCCESS_FETCH_FULL_PLAYERS';
export const FAIL_FETCH_FULL_PLAYERS = 'FAIL_FETCH_FULL_PLAYERS';

export const fetchFullPlayers = (payload, scope, callBacks) => {
  return (dispatch, getState) => {
    if (callBacks?.onRequest) {
      callBacks.onRequest();
    }
    dispatch({type: REQUEST_FETCH_FULL_PLAYERS, payload, scope});

    fetch(getEndpoint('fetchFullPlayers', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          if (callBacks?.onError) {
            callBacks.onError();
          }
          dispatch({
            type: FAIL_FETCH_FULL_PLAYERS,
            error: data.error,
            payload,
            scope,
          });
        } else {
          if (callBacks?.onSuccess) {
            callBacks.onSuccess(data);
          }
          dispatch(successFetchFullPlayers(data, payload, scope));
        }
      })
      .catch((error, type = FAIL_FETCH_FULL_PLAYERS) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchFullPlayers(response, payload, scope) {
  return dispatch => {
    dispatch({
      type: SUCCESS_FETCH_FULL_PLAYERS,
      receivedAt: Date.now(),
      success: response.success,
      response,
      payload,
      scope,
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/entities/player.js